import { render } from "./dzjy.vue?vue&type=template&id=44092c5e&scoped=true&ts=true"
import script from "./dzjy.vue?vue&type=script&lang=ts"
export * from "./dzjy.vue?vue&type=script&lang=ts"

import "./dzjy.vue?vue&type=style&index=0&id=44092c5e&lang=less&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44092c5e"]])

export default __exports__